import { useEffect, useState } from "react";
import { navLinks, brandInfo } from "@/mocks/home";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center transition-colors ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-base md:text-lg tracking-wide transition-colors ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {brandInfo.name}
            </span>
            <span
              className={`text-[10px] md:text-xs tracking-widest mt-0.5 transition-colors ${
                solid ? "text-secondary-600" : "text-background-100/80"
              }`}
            >
              爆料投稿指南
            </span>
          </span>
        </a>

        <nav
          aria-label="主导航"
          className="hidden lg:flex items-center gap-1"
        >
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                solid
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors bg-primary-500 text-background-50 hover:bg-primary-600"
          >
            <i className="ri-send-plane-fill text-base"></i>
            我要投稿
          </a>
          <button
            type="button"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <nav aria-label="移动端导航" className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 px-2 text-sm text-foreground-800 border-b border-background-100 last:border-0 hover:text-primary-700 whitespace-nowrap flex items-center justify-between"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-4 mb-1 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill text-base"></i>
              我要投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}